export default __webpack_public_path__ + "static/media/4.349da949.png";